module.exports = __webpack_public_path__ + "static/media/help-center.87a3c865.png";